import {
  IBillingNote,
  IBillingNoteUsedOrder,
  ISearchBillingNoteReq,
  ISearchBillingNoteRes,
} from '@/interfaces/billing-note';
import * as baseAdapter from './baseAdapter';

export const searchBillingNotes = async (req: ISearchBillingNoteReq) => {
  const ret = await baseAdapter.post<ISearchBillingNoteRes>(
    '/billingNote/gets',
    req,
  );
  return ret;
};

export const addBillingNote = async (data: Partial<IBillingNote>) => {
  const ret = await baseAdapter.post<IBillingNote>('/billingNote/create', data);
  return ret;
};

export const updateBillingNote = async (data: Partial<IBillingNote>) => {
  const ret = await baseAdapter.put('/billingNote/update', data);
  return ret;
};

export const getUsedBillingOrders = async (
  customerId: number,
  excludeId?: number,
) => {
  const ret = await baseAdapter.get<IBillingNoteUsedOrder[]>(
    `/billingNote/usedOrders/${customerId}${excludeId ? `?excludeId=${excludeId}` : ''}`,
  );
  return ret;
};

export const getBillingNote = async (id: number) => {
  const ret = await baseAdapter.get<IBillingNote>('/billingNote/get/' + id);
  return ret?.data;
};

export const deleteBillingNote = async (id: number) => {
  const ret = await baseAdapter.deleteRequest(`/billingNote/delete/${id}`);
  return ret;
};
